import { render } from "./milestone-form-footer-complete-button.vue?vue&type=template&id=176dda9c&scoped=true&ts=true"
import script from "./milestone-form-footer-complete-button.vue?vue&type=script&lang=ts"
export * from "./milestone-form-footer-complete-button.vue?vue&type=script&lang=ts"

import "./milestone-form-footer-complete-button.vue?vue&type=style&index=0&id=176dda9c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176dda9c"]])

export default __exports__